export interface FormCheckboxPrimary {
  className?: string
  inputClassName?: string
  name?: string
  id?: string
  ariaDescribedby?: string
  children?: JSX.Element
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string
  checked?: boolean
  isError?: boolean
}

// TODO: need refectoring for component,
// value for checkbox is string instead of boolean
export function FormCheckboxPrimary({
  className = '',
  name,
  id,
  ariaDescribedby = '',
  children,
  onChange,
  value = 'false',
  inputClassName = '',
  checked,
  isError,
}: FormCheckboxPrimary) {
  return (
    <div className={`${className} flex w-full gap-3 `}>
      <div className='w-5 mt-1'>
        <input
          id={id}
          defaultChecked={value === 'true'}
          value={value}
          onChange={onChange}
          aria-describedby={ariaDescribedby}
          name={name}
          type='checkbox'
          checked={checked}
          className={`relative box-border h-4 w-4 appearance-none rounded border checked:bg-border-primary checked:before:absolute border-dark-700 checked:before:h-4 checked:before:left-[3px] checked:before:top-[-8px] checked:border-red checked:before:content-[url('/check.svg')] ${
            isError ? 'border-red' : 'border-dark-700'
          }  ${inputClassName}`}
        />
      </div>
      <div>{children}</div>
    </div>
  )
}

export default FormCheckboxPrimary
